import { ExternalTexturePackerClipSource } from "./ExternalTexturePackerClipSource";

import { FlattenedImage } from "../FlattenedImage";
import { FrameStrip } from "../FrameStrip";
import { ClipColor } from "../../components/ClipColor";

import BitmapData = createjs.BitmapData;
import Bitmap = createjs.Bitmap;

export class ContinueLoadingTexturePackerClipSource extends ExternalTexturePackerClipSource {
    protected sourceBmp: BitmapData;

    constructor() {
        super();
    }

    public loadFrame(frame: number): void {
        let image: Bitmap = this._framesStrip.getFrame(frame - 1);
        if (image == null) {
            console.error(" we trying to load clip source which are not initialized, not supported in HTML5");
            // this._framesStrip.setFrame(frame - 1, this.renderSingleTile(this.sourceBmp, this.animData[frame - 1]));
        }
    }

    public convertClass(clipClass: Object, colorData: ClipColor[] = null, debugColor: number = 0, hasSubLayer: boolean = false): void {
        this._colorData = colorData;
        this.debugColor = debugColor;
        this.hasSubLayer = hasSubLayer;
        // TODO: @HTML5
        this._cacheId = this.sourceClass.toString(); //getQualifiedClassName(this.sourceClass);
        this.sourceBmp = new this.sourceClass();
        this.convertTexturePackerContainer(this.sourceBmp);
    }

    protected convertTexturePackerContainer(sourceBmp: BitmapData): FrameStrip {
        for (let frameIndex: number = 0; frameIndex < this.animData.length; frameIndex++) {
            this._framesStrip.addFrame(null);
        }
        return null;
    }

    public cleanUpLoadingData(): void {
        if (this.sourceBmp) {
            this.sourceBmp.dispose();
            this.sourceBmp = null;
        }
        this.animData = null;
    }
}
